/** Canonical x.isynet PVS name shared with the Rust strategy. */
export const X_ISYNET_PVS_SYSTEM_NAME = 'Medatixx x.isynet';
